import { useEffect, useState } from "react";
import ApiDatabase from "server";
import Table from "../../../../../components/table/table";
import EmptyState from "../../../../../components/EmptyState/EmptyState";
import Pagination from "../../../../../components/pagination/pagination";
import UseContext from "../../../../../hooks/useContext";

const TITLES = ['Intérimaire', 'Mission', 'Motif', 'Responsable'];

const TableSkeleton = () => (
  <table className="animate-pulse w-full">
    <tbody>
      {[1, 2, 3, 4, 5].map((i) => (
        <tr key={i}>
          {TITLES.map((_, idx) => (
            <td key={idx} className={`py-7 ${idx === 0 ? 'pl-4' : ''} ${idx === TITLES.length - 1 ? 'pr-3' : 'px-2'}`}>
              <div className="h-2 bg-gray-200 rounded" />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

const BodyVivierRatingTempWorker = ({ treated, search }) => {
  const { reviewUntreatedDelete } = UseContext();
  const [ratings, setRatings] = useState([]);
  const [isWaiting, setIsWaiting] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const limitElement = 25;
  const [totalPages, setTotalPages] = useState(0);
  const [countPerPage, setCountPerPage] = useState(0);
  const [countTotal, setCountTotal] = useState(0);

  const token = localStorage.getItem('xsrfToken');

  const fetchRatings = () => {
    setIsWaiting(true);
    const apiMethod = treated
      ? ApiDatabase.getRatingTreatedTempWorkers
      : ApiDatabase.getRatingUntreatedTempWorkers;

    apiMethod(
      { token, search, limit: limitElement, page: currentPage },
      (data) => {
        setRatings(data.reviews);
        setTotalPages(data.countPages);
        setCountPerPage(data.countPerPage);
        setCountTotal(data.count);
        setIsWaiting(false);
      },
      (err) => { if (err.name !== "CanceledError") console.error(err); }
    );
  };

  useEffect(() => {
    fetchRatings();
  }, [treated, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(fetchRatings, 400);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    if (reviewUntreatedDelete) {
      setRatings((prev) => prev.filter((r) => r._id !== reviewUntreatedDelete));
    }
  }, [reviewUntreatedDelete]);

  return (
    <div className="flex flex-col w-full h-full overflow-hidden">
      <div className="flex-1 overflow-y-auto">
        {isWaiting ? (
          <TableSkeleton />
        ) : ratings?.length > 0 ? (
          <Table champsBody={ratings} champsHeader={TITLES} />
        ) : (
          <EmptyState type="avis_clients" />
        )}
      </div>

      {totalPages > 1 && (
        <div className="flex-shrink-0 border-t border-gray-100 bg-white px-4 md:px-8 py-4">
          <Pagination
            currentPage={currentPage}
            countPerPage={countPerPage}
            countTotal={countTotal}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

export default BodyVivierRatingTempWorker;